import { type RouteObject } from 'react-router'

import { SAVED_VIEWS_URL } from 'features/saved-views/paths'
import { lazyDefault } from 'routes/lazy-route'

export const savedViewsRoutes: RouteObject[] = [
  {
    path: SAVED_VIEWS_URL,
    lazy: lazyDefault(() => import('features/saved-views/Container')),
    handle: { featureKey: SAVED_VIEWS_URL },
  },
]
